import { render, staticRenderFns } from "./GachaResult.vue?vue&type=template&id=79228b2a&"
import script from "./GachaResult.vue?vue&type=script&lang=ts&"
export * from "./GachaResult.vue?vue&type=script&lang=ts&"
import style0 from "./GachaResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports